// @ts-nocheck
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export interface PartFinderProps {
    partQtyInUnit?: TypographyPresentationProps;
    productQtyFormField?: TextFieldPresentationProps;
    addToCartButton?: ButtonPresentationProps;
}

export const partFinderProps: PartFinderProps = {
    partQtyInUnit: {
        css: css`
            display: block;
            font-size: ${x => x.theme.design.typography.size.smaller};
            color: ${getColor("neutral")};
        `,
    },
    productQtyFormField: {
        sizeVariant: "small",
        cssOverrides: {
            formField: css`
                ${x => x.theme.formField.defaultProps?.cssOverrides?.formField}
                flex-direction:row-reverse;
                min-width: ${pxToRem(130)};
                > label {
                    align-self: center;
                    padding: ${pxToRem(7, 20, 0, 10)};
                }
            `,
        },
    },
    addToCartButton: {
        variant: "secondary",
        css: css`
            ${x => x.theme.button.secondary.css}
            align-self: flex-end;
            white-space: nowrap;
            margin-top: auto;
        `,
    },
};
